import { CompanyData } from '../company.types';
//import { PrivacyPolicy } from "./privacy";
//import { TermsConditions } from "./terms";
import { getCompanyEnvironmentConfig } from '../utils';
import { environmentConfigs } from './auth';
import { logoData } from './logos';
import { getCompanyTheme } from './theme';
import {
    getTranslationsResources,
    translationsVariables,
} from './translations';

export const TriumphPartnerId = 'faasbytriumph.io';

export const getTriumphData: () => CompanyData = () => ({
    theme: getCompanyTheme(),
    translationsResources: getTranslationsResources(),
    translationsVariables,
    PrivacyComponent: undefined, //PrivacyPolicy,
    TermsComponent: undefined, //TermsConditions,
    logos: logoData,
    environmentConfig: getCompanyEnvironmentConfig(environmentConfigs),
    partnerId: TriumphPartnerId,
});
